"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var latestVersion = _ref.latestVersion,
      versions = _ref.versions;
  return versions.find(function (_ref2) {
    var versionNumber = _ref2.versionNumber;
    return versionNumber === latestVersion;
  }) || {};
}